import { autoinject } from "aurelia-dependency-injection";
import type { UserSecurityInfoModel } from "../../models/user.models";
import * as moment from "moment";
import { UserClientService } from "../basic/user-client.service";
import { ConfigService } from "../basic/config.service";
import { CompTabs } from "../../components/comp-tabs/comp-tabs";
import * as DOMPurify from "dompurify";
import { Router } from "aurelia-router";

@autoinject
export class IntercomService {

    private _isIntercomInitialized: boolean = false;

    constructor(private router: Router, private configService: ConfigService, private userClientService: UserClientService) {

    }

    //Init Intercom
    init(user: UserSecurityInfoModel, intercomHash: string) {
        if(this.configService.config.settings.intercomAppId) {

            //Get current user
            this.userClientService.getCurrentUser().then(x => {
                const businessUnit = x && x.businessUnit ? x.businessUnit.businessUnitName : 'n/a';
                const company = x && x.businessUnit ? x.businessUnit.customerName : 'n/a';
                let createdDateUnixTime = null;
                if (user && user.createdDate) {
                    createdDateUnixTime = moment(user.createdDate).unix();
                }
                //Intercom settings
                window["IntercomSettings"] = {
                    app_id: this.configService.config.settings.intercomAppId,
                    name: user.userName,
                    email: user.email,
                    created_at: createdDateUnixTime,
                    Company: company,
                    "Business Unit": businessUnit,
                    utm_campaign: x.user.campaign,
                    utm_content: x.user.campaignIdentifier,
                    utm_source: x.user.campaignSource,
                    utm_medium: x.user.campaignMedium
                }

                //Check if Intercom is initialized, if not, call 'boot()'
                if (!this._isIntercomInitialized) {
                    this.boot(user.email, intercomHash);
                    this._isIntercomInitialized = true;
                }

                //Update Intercom
                window["Intercom"]('update', window["IntercomSettings"]);
            });
        }
    }

    //Boot Intercom
    public boot(email: string, intercomHash: string, customLauncherSelector: string = '.intercom-trigger') {
        if(email && intercomHash) {
            (<any>window).Intercom("boot", {
                app_id: this.configService.config.settings.intercomAppId,
                email: email,
                user_hash: intercomHash,
                custom_launcher_selector: customLauncherSelector,
                hide_default_launcher: true
            });
        }
        else {
            (<any>window).Intercom("boot", {
                app_id: this.configService.config.settings.intercomAppId,
                custom_launcher_selector: customLauncherSelector,
                hide_default_launcher: true
            });
        }
    }

    //Update Intercom
    public update() {
        if (window && window["IntercomSettings"]) {
            window["IntercomSettings"]["Platform page"] = window.location.href;
            const tabs = document.getElementsByTagName("tabs");
            const tabsVm = tabs.length > 0 ? (<CompTabs>(<any>tabs[0]).au.controller.viewModel) : null;
            window["IntercomSettings"]["Tab page"] = tabsVm && tabsVm.currentTab ? this.senitize(tabsVm.getTabTitle(tabsVm.currentTab)) : 'n/a';
            window["IntercomSettings"]["Record id"] = this.router.currentInstruction.params && this.router.currentInstruction.params.id ? this.router.currentInstruction.params.id : "n/a";
            window["Intercom"]('update');
        }
    }

    //Sentize
    private senitize(html: string) {
        const div = document.createElement('div');
        div.innerHTML = DOMPurify.sanitize(html);
        const text = div.textContent;
        div.remove();
        return text;
    }
}